(function () {
    Object.makeEnum = function (arr) {
        let obj = Object.create(null);
        for (let val of arr) {
            obj[val] = Symbol(val);
        }
        return Object.freeze(obj);
    }
})();
